var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConstellation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2461_6366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99231 6.94238L7.03662 8.64343V12.0489L9.99231 13.7567L12.948 12.0489V8.64343L9.99231 6.94238Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57812 15.7354L9.76545 20.4631L12.4946 15.7354H1.57812Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4834 5.32246L4.08062 9.82701L9.27844 0.821289L1.4834 5.32246Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4895 4.96769H17.875L10.0901 0.463135L7.4895 4.96769Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4014 5.48828L18.5958 14.494V5.48828H13.4014Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8966 10.8726L10.7056 19.8783L18.4938 15.3771L15.8966 10.8726Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38892 15.2115H6.58335L1.38892 6.20581V15.2115Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2461_6366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstellation);
export default __webpack_public_path__ + "static/media/constellation.e6425eb0ad41a7bd7b0e169227e9020d.svg";
export { ForwardRef as ReactComponent };